/** Inclusive max width for the stacked/compact product layout. Desktop is strictly above this. */
export const PRODUCT_COMPACT_MAX_WIDTH = 1200;

export function isProductCompactViewport(width: number): boolean {
    return width <= PRODUCT_COMPACT_MAX_WIDTH;
}

export function isProductDesktopViewport(width: number): boolean {
    return width > PRODUCT_COMPACT_MAX_WIDTH;
}
